<template>
    <b-modal id="modal-cancelar-aplicacoes-multiplas-doses" centered hide-header hide-footer no-close-on-backdrop no-close-on-esc
        size="lg" modal-class="modal-aplicacoes-realizadas" v-model="showModal">
        <div class="my-2">
            <h3 class="text-center mb-2">Aplicações realizadas</h3>
            <b-table :items="aplicacoesFiltradas" :fields="fields" responsive small striped bordered>
                <template #cell(data_aplicacao)="{ item }">
                    {{ formatDate(item.data_aplicacao) }}
                </template>

                <template #cell(situacao)="{ item }">
                    <b-badge :variant="item.situacao === 'Finalizada' ? 'success' : 'primary'">
                        {{ item.situacao }}
                    </b-badge>
                </template>

                <template #cell(cancelar)="{ item }">
                    <b-button v-if="podeCancelar(item)" size="sm" variant="outline-danger"
                        @click="acionarCancelamento(item)">
                        Cancelar
                    </b-button>
                </template>
            </b-table>

            <div class="d-flex justify-content-center mt-2">
                <b-button variant="secondary" @click="$emit('close')">Fechar</b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { BModal, BButton, BTable, BBadge } from 'bootstrap-vue';

export default {
    name: 'ModalCancelarAplicacoesMultiplasDoses',
    components: {
        BModal,
        BButton,
        BTable,
        BBadge,
    },
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        colaborador: {
            type: Array,
            default: null,
        },
        isSuporte: {
            type: Boolean,
            default: false,
        },
        isVacinadorPadrao: {
            type: Boolean,
            default: false,
        },
        canExclude: {
            type: Boolean,
            default: false,
        },
        canCancelFinalizedVaccination: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fields: [
                { key: 'nome', label: 'Nome' },
                { key: 'nome_tecnico', label: 'Vacina' },
                { key: 'descricao_dose', label: 'Dose' },
                { key: 'numero_lote', label: 'Lote' },
                { key: 'data_aplicacao', label: 'Data Aplicação' },
                { key: 'situacao', label: 'Status', tdClass: 'text-center' },
                { key: 'cancelar', label: 'Ação', tdClass: 'text-center' },
            ],
        };
    },
    computed: {
        aplicacoesFiltradas() {
            if (!Array.isArray(this.colaborador)) return [];
            return this.colaborador.filter((a) =>
                ['Aplicada', 'Finalizada'].includes(a.situacao)
            );
        },
    },
    methods: {
        formatDate(date) {
            if (!date) return '-';
            return new Date(date).toLocaleDateString('pt-BR');
        },
        acionarCancelamento(aplicacao) {
            const payload = { colaborador: [aplicacao] };
            if (aplicacao.situacao === 'Finalizada') {
                this.$emit('estornar', payload);
            } else {
                this.$emit('cancelar', payload);
            }
        },
        podeCancelar(item) {
            if (!item) return false;
            if (item.situacao === 'Aplicada' && !this.isSuporte && !this.isVacinadorPadrao) {
                return this.canExclude;
            }
            if (item.situacao === 'Finalizada') {
                return this.canCancelFinalizedVaccination;
            }
            return false;
        },
    },
};
</script>

<style scoped>
.text-center {
    text-align: center;
}
</style>

<style>
.modal-aplicacoes-realizadas .modal-dialog {
    max-width: 1200px;
}
</style>
